import React from 'react';

export default function PersonalizeCheck() {
  return (
    <div style={{ maxWidth: 700, margin: '60px auto', padding: '0 20px', textAlign: 'center' }}>
      <h1>Personalize Check</h1>
      <p>Review your personalized invitation before submitting for print.</p>
    </div>
  );
}
